import './assets/css/tailwind.css';

import Pagination from './components/Pagination';
import VueAdsPageButton from './components/PageButton';

export default Pagination;

export { VueAdsPageButton };
